<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>

      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Reporte de Corte de caja detalle</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>RP_01_DET_CAJA</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          Búsqueda de clinicas
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>

              <b-form-group align="left">
                <label for="clinica">Clinicas</label>
                <v-select v-if="!todas" name="clinica" placeholder="Clinicas"
                          label="strNombre"
                          multiple
                          :reduce="(variable) => variable.idClinica"
                          :options="clinicas"
                          v-model="filtro.idClinicas"
                ></v-select>
                <b-form-checkbox
                    id="checkbox-1"
                    v-model="todas"
                    name="checkbox-1"
                    @change="todos()">
                  Todas las clinicas
                </b-form-checkbox>
              </b-form-group>

            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group align="left">
                <label for="fci">Fecha de inicio</label>
                <b-input-group size="sm" class="mb-2" id="fci" lab>
                  <b-form-datepicker name="nombre" placeholder="Fecha de Inicio"
                                     :max="new Date()"
                                     v-model="$v.filtro.fechaInicio.$model"
                                     :state="validateState('fechaInicio')"
                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group align="left">
                <label for="fcf">Fecha de fin</label>
                <b-input-group size="sm" class="mb-2" id="fcf" lab>
                  <b-form-datepicker name="nombre" placeholder="Fecha de Fin"
                                     :min="filtro.fechaInicio"
                                     :max="new Date()"
                                     v-model="$v.filtro.fechaFin.$model"
                                     :state="validateState('fechaFin')"

                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col></b-col>
            <b-col></b-col>
            <b-col class="text-right">
              <b-button variant="outline-primary" :disabled="loader" @click="obtenerDatos()">
                <span v-if="!loader">Buscar</span>
                <span v-else>
                                     <b-spinner small></b-spinner>
                                    Buscando...
                                </span>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col>
          <download-excel
              v-if="datosTabla.length > 0 && $localStorageService.can('CC_expor_detalle_excel')"
              class="btn btn-primary"
              :data="datosTabla"
              :fields="fieldsExcel"

              worksheet="My Worksheet"
              name="Reporte corte.xls"
          >
            Generar Excel
            <em class="fa fa-file-excel-o"></em>
          </download-excel>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div v-if="!loader" class="overflow-auto">
            <b-table
                id="Pendientes"
                thead-tr-class="columnas"
                :items="datosTabla"
                :fields="fields"
                striped
                responsive="true"
                class="parrafos"
                :per-page="registrosPorPagina"
                :current-page="paginaActual"
            >
              <template v-slot:cell(fecha)="row">
                {{row.item.fecha}}
              </template>
            </b-table>
          </div>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="buscado">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
              <b-pagination
                      v-if="datosTabla !== undefined && datosTabla.length > 10"
                      align="center"
                      v-model="paginaActual"
                      :total-rows="datosTabla.length"
                      :per-page="registrosPorPagina"
                      aria-controls="my-table1"
              ></b-pagination>
          </b-col>
        </b-col>


      </b-row>

    </b-container>

  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import Header from "@/components/Header";

export default {
  components: {
    Header
  },
  name: "reporteCorte",
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      registrosPorPagina: 200,
      paginaActual: 1,
      loader: false,
      buscado: false,
      filtro: {
        idClinicas: [],
        fechaInicio: null,
        fechaFin: null
      },
      fields: [
        {key: "idTratamientoProgramado", label: "IdTratamientoProgramado", sortable: true},
        {key: "idClinica", label: "IdClinica", sortable: true},
        {key: "clinica", label: "Clinica", sortable: true},
        {key: "fecha", label: "Fecha", sortable: true},
        {key: "recibo", label: "Recibo", sortable: true},
        {key: "factura", label: "Factura"},
        {key: "notaCredito", label: "N. Cred"},
        {key: "idPaciente", label: "Id paciente", sortable: true},
        {key: "nombrePaciente", label: "Nombre Paciente", sortable: true},
        {key: "rfcPaciente", label: "RFC Paciente"},
        {key: "terminal", label: "Terminal"},
        {key: "idTratamiento", label: "Id Tratamiento", sortable: true},
        {key: "tratamiento", label: "Tratamiento", sortable: true},
        {key: "totaltx", label: "Total de Tx"},
        {key: "importe", label: "Importe"},
        {key: "pagoAnticipado", label: "Pago Anticipado"},
        {key: "aplicacionSaldo", label: "Aplicacion de saldo"},
        {key: "adeudo", label: "Adeudo"},
        {key: "efectivo", label: "Efectivo"},
        {key: "transferencia", label: "Transf Electronica"},
        {key: "financiamiento", label: "Financiamiento"},
        {key: "tdc", label: "T. Credito"},
        {key: "mercadoPago", label: "Mercado Pago"},
        {key: "tdd", label: "T. Debito"},
        {key: "pagoAdeudo", label: "Pago de Adeudo"},
        {key: "msi", label: "MSI"}
      ],
      fieldsExcel: {
        "IdTratamientoProgramado": "idTratamientoProgramado",
        "IdClinica": "idClinica",
        "Clinica": "clinica",
        "Fecha": "fecha",
        "Recibo": "recibo",
        "Factura": "factura",
        "N. Cred": "notaCredito",
        "Id paciente": "idPaciente",
        "Nombre Paciente": "nombrePaciente",
        "RFC Paciente": "rfcPaciente",
        "Terminal": "terminal",
        "Id Tratamiento":"idTratamiento",
        "Tratamiento": "tratamiento",
        "Total de Tx": "totaltx",
        "Importe": "importe",
        "Pago Anticipado": "pagoAnticipado",
        "Aplicacion de saldo": "aplicacionSaldo",
        "Adeudo": "adeudo",
        "Efectivo": "efectivo",
        "Transf Electronica": "transferencia",
        "Financiamiento": "financiamiento",
        "T. Credito": "tdc",
        "Mercado Pago": "mercadoPago",
        "T. Debito": "tdd",
        "Pago de Adeudo": "pagoAdeudo",
        "MSI": "msi",
      },
      datosTabla: [],
      clinicas: [],
      todas: false,

    }
  },
  validations: {
    filtro: {
      fechaInicio: {required},
      fechaFin: {required},
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerClinicas()
  },
  methods: {
    obtenerClinicas() {
      this.$http.get(this.$api + 'catalogos/listaClinicas').then(respuesta => {
        if (respuesta.data.data) {
          this.clinicas = respuesta.data.data;
        }
      })
    },
    obtenerDatos() {
      this.$v.filtro.$touch();

      if (!this.todas && this.filtro.idClinicas.length == 0) {
        this.$swal({
          icon: "error",
          text: "Debe seleccionar al menos una clínica para realizar la búsqueda",
        });
      } else {
        if (!this.$v.filtro.$invalid) {

          this.datosTabla = [];
          const inicio = new Date(this.filtro.fechaInicio);
          inicio.setDate(inicio.getDate() +1);
          inicio.setHours(0, 0, 0, 0);
          const fin= new Date(this.filtro.fechaFin)
          fin.setHours(23, 59, 59, 999);

          this.loader = true
          this.buscado = false

          const envio = {
            idClinicas: this.todas ? [-1] : this.filtro.idClinicas,
            fechaInicio: this.$moment(inicio).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
            fechaFin: this.$moment(fin).add(1, 'days').utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
            horas: this.$horas()
          }


          this.$http.post(this.$api + 'diagnostico/reporte/CorteCaja', envio).then(respuesta => {
                if (respuesta.data.data) {
                  this.datosTabla = respuesta.data.data
                }
              }
          ).finally(() => {
                this.loader = false;
                this.buscado = true;
              }
          )
        }
      }
    },
    todos() {
      this.todas = !this.todas;
      this.filtro.idClinicas = []
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.filtro[name];
      return $dirty ? !$error : null;
    },
  }
}
</script>

<style scoped>

</style>
